import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, Observable, take } from 'rxjs';
import { LocalStorageService } from 'app/storage/local-storage-service';
import { UserType } from '@shared/enums/user-type';

@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly router = inject(Router);
  private readonly localStorage = inject(LocalStorageService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.oidcSecurityService.checkAuth().pipe(
      take(1),
      map(({ isAuthenticated }) => {
        if (isAuthenticated) {
          const user = this.localStorage.getUserProfile();
          if (user?.userType === UserType.INTERNAL_USER) {
            return this.router.createUrlTree(['/mis/dashboard']);
          }
          return this.router.createUrlTree(['/services-selection']);
        }
        return true;
      }),
    );
  }
}
